import { useFavorites } from "@/hooks/useFavorites";

interface FavoriteButtonProps {
  movieId: string;
  movieTitle: string;
}

export default function FavoriteButton({ movieId, movieTitle }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites();
  const active = isFavorite(movieId);

  return (
    <button
      type="button"
      aria-pressed={active}
      aria-label={active ? `取消收藏《${movieTitle}》` : `收藏《${movieTitle}》`}
      onClick={() => toggleFavorite(movieId)}
      className={`flex min-h-[44px] cursor-pointer items-center gap-2 whitespace-nowrap rounded-md border px-4 py-2.5 text-sm font-medium transition-colors ${
        active
          ? "border-primary-300 bg-primary-100 text-primary-700"
          : "border-background-300 bg-background-50 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
      }`}
    >
      <i className={active ? "ri-bookmark-fill" : "ri-bookmark-line"} />
      {active ? "已收藏" : "收藏本片"}
    </button>
  );
}